import React from "react";

/**
 * Shared collapsible-section header for the filter sidebar. Used by every
 * facet / range / notes section so they stay visually identical.
 *
 *   title    — section label
 *   expanded — whether the body is open (drives the chevron)
 *   onToggle — collapse / expand handler
 *   count    — number of active filters in this section; renders a badge when > 0
 *              so a collapsed section still advertises that it's filtering.
 */
export function FacetSectionHeader({ title, expanded, onToggle, count = 0 }) {
    return (
        <button
            type="button"
            className="asp-facet-header"
            onClick={onToggle}
            aria-expanded={expanded}
        >
            <span className="asp-facet-title">{title}</span>
            {count > 0 && (
                <span className="asp-facet-badge" aria-label={`${count} active filter${count !== 1 ? "s" : ""}`}>
                    {count}
                </span>
            )}
            <svg
                className={`asp-chevron ${expanded ? "open" : ""}`}
                width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round"
                aria-hidden="true"
            >
                <polyline points="6 9 12 15 18 9" />
            </svg>
        </button>
    );
}
